import API from "@aws-amplify/api";
// import { useState } from "react";
import { useEffect, useContext, useState } from "react";

import { ApiName, RedminePath } from "../actions";
import AppContext from "../contexts/AppContext";

// const apiName = "redmineProxyApi";
// const path = "/v1/redmine/proxy";
export const useProjectTracker = () => {
  const { state, dispatch } = useContext(AppContext);

  const [trackers, setTrackers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedTrackerId, setSelectedTrackerId] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [init, setInit] = useState(false);

  const [redmineUrl, setRedmineUrl] = useState("");
  const [apiKey, setApiKey] = useState("");

  useEffect(() => {
    setRedmineUrl(state.current.redmineurl);
    setApiKey(state.current.apikey);
    setInit(true);
  }, [state.current]);

  const getProjectTrackers = (props) => {
    setLoading(true);
    const { project_id } = props;
    const myInit = {
      // OPTIONAL
      headers: {
        "Content-type": "application/json",
        "X-Api-Key": apiKey,
      }, // OPTIONAL
      queryStringParameters: {
        path: "projects/" + project_id + ".json?include=trackers",
        url: redmineUrl,
      },
    };
    console.log("headers", myInit);
    if (apiKey && project_id) {
      API.get(ApiName, RedminePath, myInit)
        .then((res) => {
          setTrackers(res.success.project.trackers);
          setSelectedTrackerId(res.success.project.trackers[0].id);
          console.log("success");
        })
        .catch((err) => {
          setErrorMessage("エラーが発生しました。");
          console.log("エラー", err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };
  return {
    trackers,
    selectedTrackerId,
    setSelectedTrackerId,
    loading,
    getProjectTrackers,
    errorMessage,
    init,
  };
};
